import { render, staticRenderFns } from "./UserCreation.vue?vue&type=template&id=7b8b12a4&scoped=true"
import script from "./UserCreation.vue?vue&type=script&lang=js"
export * from "./UserCreation.vue?vue&type=script&lang=js"
import style0 from "./UserCreation.vue?vue&type=style&index=0&id=7b8b12a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8b12a4",
  null
  
)

export default component.exports